import type { FaireProductEntity } from "../../entity_types/product";

export const starter_collection_108: FaireProductEntity = {
  token: "starter_collection_108",
  type: "product",
  name: "Best Wine Key - Big Red",
  brandName: "Craighill",
  imageUrl:
    "https://cdn.faire.com/fastly/447e6d38bdd515de62fd3f7fed1514b78a394dcb608026c307979cf314b66eed.jpeg?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=1440&width=1440",
  priceDollars: 48,
  msrpDollars: 96,
  description: "Migrated starter collections product",
  tags: ["starter-collections"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
